import React from "react";
import "./SimpleCard.css";

const SimpleCard = ({ imageUrl, heading }) => {
  return (
    <div className="inner-container-first simple-card">
      <div className="inner-image">
        <img src={imageUrl} alt={heading} />
      </div>
      <div className="card-heading-overlay">
        <h3 className="card-heading">{heading}</h3>
      </div>
    </div>
  );
};

export default SimpleCard;
